module.exports = __webpack_public_path__ + "static/media/finBigPic.78f0e982.jpg";